import { useState } from 'react';

import useResize from 'js/hooks/use-resize';

interface ChildProps {
  className?: string;
}

type ChildComponent = React.FC<React.PropsWithChildren<ChildProps>>;

const ChildHoF = (setHeight: (height: string) => void): ChildComponent => {
  const Child: ChildComponent = ({ children, className }) => {
    const forceUpdate = useState<number>(0)[1];

    useResize(() => forceUpdate(prev => prev + 1));

    return (
      <div className={className} ref={node => node && node.clientHeight && setHeight(`${node.clientHeight}px`)}>
        {children}
      </div>
    );
  };

  return Child;
};

interface HeightOfChildProps {
  children: (Child: ChildComponent) => React.ReactNode;
  className?: string;
}

// Internal helper component - not exported
// eslint-disable-next-line react/no-multi-comp
const HeightOfChild: React.FC<HeightOfChildProps> = ({ children, className }) => {
  const [height, setHeight] = useState<string | undefined>(undefined);

  return (
    <div className={className} style={{ height }}>
      {children(ChildHoF(setHeight))}
    </div>
  );
};

HeightOfChild.displayName = 'HeightOfChild';

export default HeightOfChild;
